import { useEffect, useState } from 'react';

/**
 * Basic hook to fetch Contacts from the page object and de-serialise.
 *
 * @param {import('../Kalkhoff').Page} page A WordPress page object
 * @returns {Array<import('../Kalkhoff').SparseContact[]>}
 *          returns the `contacts` state.
 */
export default function useContacts(page) {
  const [ contacts, setContacts ] = useState([]);

  useEffect(() => {
    if (page.kalkhoff_custom_fields) {
      // Using a poor man's deserialiser to go from PHP-serialised to JSON
      const cleanFields = `[${
        page.kalkhoff_custom_fields.kalkhoff_contact_data[0]
            // strip control chars
            .replace(/([a-z]:[0-9]+(:|;))+/gi, '\n')
            // create key-value pairs
            .replace(/("[^"]*");\n?("[^"]*");\n?/gi, '$1:$2,\n')
            // Add separators
            .replace(/,\n\}/g, '},')
            // Trim start/end junk
            .slice(2, -2)
      }]`;
      const kalkhoffCustomField = JSON.parse(
          cleanFields,
      );
      setContacts(kalkhoffCustomField);
    }
  }, [ page.kalkhoff_custom_fields ]);

  return [ contacts ];
}
